








import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

@Component
export default class BaseTLTest extends Vue {
	@Prop({ type: String, required: false, default: "" }) label?: string; //hlavní popis
	@Prop({ type: String, required: false, default: "6" }) labelWidth?: string; //šířka
	@Prop({ type: String, required: false, default: "6" }) inputWidth?: string; //širka druheho
	//@Prop({ required: true }) items: any; //mapovani list/ nebo jeden prvek
	@Prop({ type: Boolean, required: false, default: false }) onlyOne?: boolean; //pouze jeden prvek

	//name() {
	//	return this.items == null ? '' : this.items.name;
	//}

	//načtení stylu
	get inputClass(){
		return {			
			"labelDetailFormHead": true
		//	,				"label-design-head-bigger": this.isBig == true
		};
	}

	goToDetail(item: any): void {
		this.$emit('selectItem', item);
	}



}
